import {Route} from 'react-router';
import {CoachHomepage} from '@components/microfrontends/CoachHomepage';
import React from 'react';

export const homepageRoutes = (
  <Route path="home" component={CoachHomepage}>
    <Route path="*" component={CoachHomepage} />
  </Route>
);
